enum PrintStatus {
    NONE = "",
    /* 未打印快递单 */
    NOT_PRINT_WAYBILL = "notPrintWaybill",
    /* 未打印发货单 */
    NOT_PRINT_PACKING_LIST = "notPrintPackingList",
    /* 已打印快递单 */
    PRINTED_WAYBILL = "printedWaybill",
    /* 已打印发货单 */
    PRINTED_PACKING_LIST = "printedPackingList",
    /* 快递单打印次数 */
    PRINT_WAYBILL_COUNT_EQ_1 = "printWaybillCountEq1",
    PRINT_WAYBILL_COUNT_GT_1 = "printWaybillCountGt1",
    /** 查询商品标签已打印的订单 */
    ORDER_ITEM_LABEL_PRINTED = "orderItemLabelPrinted",
    /** 查询商品标签未打印的订单 */
    NOT_ORDER_ITEM_LABEL_PRINTED = "notOrderItemLabelPrinted",

    WAYBILL_NO_GENERATED_ONLY = "waybillNoGeneratedOnly",

    /** 已打印拿货标签（订单中至少有一个订单项已打印） */
    PURCHASING_LABEL_PRINTED = "purchasingLabelPrinted",
    /** 未打印拿货标签（订单中全部订单项都未打印） */
    NOT_PURCHASING_LABEL_PRINTED = "notPurchasingLabelPrinted",
}

export default PrintStatus;
